<div class="container-fluid  row_banner pb-5">
    <app-header></app-header>
    <div class="row row_banner_signin justify-content-center">
        <div class="col-lg-12" style="text-align: center; margin-top: 8%;"> <img
                src="../../assets/images/icons/failed.svg" alt="failed">
            <h3 style="margin-top:1% ;">Sorry!</h3>
            <p style="margin-top: 1%;font-size: 23px;">Your transaction has failed. Please go back and try again.</p>
            <button type="button" class="btn btn-dark" style="height: 50px; margin-top: 1%;"
            [routerLink]="['/pricing']" >Back to Pricing </button>               
        </div>
    </div>
</div>
<app-footer></app-footer>
